import React from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  grayMedium,
  moovsBlue,
  moovsBlueSelected,
  successGreen,
} from "globals/design-system/colors";
import { DriverScheduleSettingScheduleTypeEnum } from "types";
import { CheckIcon } from "globals/design-system/icons";
import BlockIcon from "globals/design-system/icons/info/BlockIcon";

const { Available, Unavailable } = DriverScheduleSettingScheduleTypeEnum;

type EventTypeSelectorProps = {
  value: DriverScheduleSettingScheduleTypeEnum;
  onChange?: (eventType: DriverScheduleSettingScheduleTypeEnum) => void;
  disabled?: boolean;
};

function EventTypeSelector({
  value,
  onChange,
  disabled = false,
}: EventTypeSelectorProps) {
  const handleClick = (eventType: DriverScheduleSettingScheduleTypeEnum) => {
    if (!disabled && onChange) {
      onChange(eventType);
    }
  };

  return (
    <Box display="flex" gap={2} mb={3} justifyContent="space-between">
      <Button
        variant="outlined"
        color="primary"
        onClick={() => handleClick(Available)}
        disabled={disabled}
        fullWidth
        sx={{
          borderColor: value === Available ? moovsBlue : grayMedium,
          bgcolor: value === Available ? moovsBlueSelected : "transparent",
          padding: 2,
          cursor: disabled ? "default" : "pointer",
          "&:hover": {
            borderColor: value === Available ? moovsBlue : grayMedium,
            bgcolor:
              value === Available
                ? moovsBlueSelected
                : disabled
                ? "transparent"
                : "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={1}
        >
          <CheckIcon color={successGreen} />
          <Typography variant="body1" fontWeight={500}>
            Available
          </Typography>
        </Box>
      </Button>

      <Button
        variant="outlined"
        onClick={() => handleClick(Unavailable)}
        disabled={disabled}
        fullWidth
        sx={{
          borderColor: value === Unavailable ? moovsBlue : grayMedium,
          bgcolor: value === Unavailable ? moovsBlueSelected : "transparent",
          padding: 2,
          cursor: disabled ? "default" : "pointer",
          "&:hover": {
            borderColor: value === Unavailable ? moovsBlue : grayMedium,
            bgcolor:
              value === Unavailable
                ? moovsBlueSelected
                : disabled
                ? "transparent"
                : "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={1}
        >
          <BlockIcon />
          <Typography variant="body1" fontWeight={500}>
            Block
          </Typography>
        </Box>
      </Button>
    </Box>
  );
}

export default EventTypeSelector;